export default "__VITE_ASSET__CgGMJNRG__"